import styled from "styled-components";
import { SectionTitle } from "../SectionTitle";
import { misc, util } from "@/common/theme";
import { setTypography } from "@/mono/lib/styles/mixins";
import { useMemo, useRef } from "react";
import { mediaMobile } from "@/mono/lib/responsive";
import { useScrollRigScrollTrigger } from "@/mono/lib/hooks/useScrollRigScrollTrigger";
import CustomSplitText from "@/mono/components/CustomSplitText";
import BorderedIcon from "../BorderedIcon";
import { TransitionLink } from "@/mono/components/TransitionLink";
import Link from "next/link";
import { useIsClient } from "@/mono/lib/hooks/useIsClient";
import { BoxedLogo } from "components/Logo";
import SplitText from "mono/components/SplitText";
import { mediaTablet } from "mono/lib/responsive";

export function Footer() {
  const items = useRef([]);
  const wrapper = useRef();

  useScrollRigScrollTrigger({
    el: wrapper,
    offset: -0.25,
    handleIn: () => {
      items.current.forEach((item, index) => {
        if (!item) return;
        item?.animateIn({ delay: index * 0.04 });
      });
    },
  });

  const year = useMemo(() => new Date().getFullYear(), []);

  let itemIndex = useMemo(() => 0, []);
  const itemProps = {
    animateOnScroll: false,
  };

  const isClient = useIsClient();
  if (!isClient) return null;

  return (
    <footer ref={wrapper}>
      <SectionTitle>Get in touch</SectionTitle>
      <Wrapper>
        <FooterInner>
          <div className="footer-inner__left">
            <ul>
              <li>
                <SplitText
                  tag={"strong"}
                  {...itemProps}
                  ref={(r) => (items.current[itemIndex++] = r)}
                >
                  Breda
                </SplitText>
              </li>
              <li>
                <SplitText
                  tag="p"
                  {...itemProps}
                  ref={(r) => (items.current[itemIndex++] = r)}
                >
                  Willemstraat 16
                </SplitText>
              </li>
              <li>
                <SplitText
                  tag="p"
                  {...itemProps}
                  ref={(r) => (items.current[itemIndex++] = r)}
                >
                  4811 AL Breda
                </SplitText>
              </li>
              <li>
                <SplitText
                  tag="p"
                  {...itemProps}
                  ref={(r) => (items.current[itemIndex++] = r)}
                >
                  The Netherlands
                </SplitText>
              </li>
              <li>
                <Link href="mailto:cu@nine.nl">
                  <SplitText
                    tag="p"
                    {...itemProps}
                    ref={(r) => (items.current[itemIndex++] = r)}
                  >
                    cu@nine.nl
                  </SplitText>
                </Link>
              </li>
            </ul>
            <ul>
              <li>
                <SplitText
                  tag={"strong"}
                  {...itemProps}
                  ref={(r) => (items.current[itemIndex++] = r)}
                >
                  Rotterdam
                </SplitText>
              </li>
              <li>
                <SplitText
                  tag="p"
                  {...itemProps}
                  ref={(r) => (items.current[itemIndex++] = r)}
                >
                  Goudsesingel 194
                </SplitText>
              </li>
              <li>
                <SplitText
                  tag="p"
                  {...itemProps}
                  ref={(r) => (items.current[itemIndex++] = r)}
                >
                  3011 KD Rotterdam
                </SplitText>
              </li>
              <li>
                <SplitText
                  tag="p"
                  {...itemProps}
                  ref={(r) => (items.current[itemIndex++] = r)}
                >
                  The Netherlands
                </SplitText>
              </li>
            </ul>
            <ul>
              <li>
                <SplitText
                  tag={"strong"}
                  {...itemProps}
                  ref={(r) => (items.current[itemIndex++] = r)}
                >
                  Menu
                </SplitText>
              </li>
              <li>
                <TransitionLink href="/projects">
                  <SplitText
                    tag="p"
                    {...itemProps}
                    ref={(r) => (items.current[itemIndex++] = r)}
                  >
                    Projects
                  </SplitText>
                </TransitionLink>
              </li>
              <li>
                <TransitionLink href="/about-us">
                  <SplitText
                    tag="p"
                    {...itemProps}
                    ref={(r) => (items.current[itemIndex++] = r)}
                  >
                    About us
                  </SplitText>
                </TransitionLink>
              </li>
              <li>
                <TransitionLink href="/what-we-do">
                  <SplitText
                    tag="p"
                    {...itemProps}
                    ref={(r) => (items.current[itemIndex++] = r)}
                  >
                    What we do
                  </SplitText>
                </TransitionLink>
              </li>
              <li>
                <Link href="mailto:cu@nine.nl">
                  <SplitText
                    tag="p"
                    {...itemProps}
                    ref={(r) => (items.current[itemIndex++] = r)}
                  >
                    Contact
                  </SplitText>
                </Link>
              </li>
            </ul>
            <ul>
              <li>
                <SplitText
                  tag={"strong"}
                  {...itemProps}
                  ref={(r) => (items.current[itemIndex++] = r)}
                >
                  Follow us
                </SplitText>
              </li>
              <li>
                <Link
                  href="https://www.linkedin.com/company/938792/admin/dashboard/"
                  target="_blank"
                >
                  <SplitText
                    tag="p"
                    {...itemProps}
                    ref={(r) => (items.current[itemIndex++] = r)}
                  >
                    LinkedIn
                  </SplitText>
                </Link>
              </li>

              <li>
                <Link
                  href="https://www.instagram.com/ninecreativeagency/"
                  target="_blank"
                >
                  <SplitText
                    tag="p"
                    {...itemProps}
                    ref={(r) => (items.current[itemIndex++] = r)}
                  >
                    Instagram
                  </SplitText>
                </Link>
              </li>

              {/* <li>
                <Link href="https://vimeo.com/ninefilms" target="_blank">
                  <SplitText
                    tag="p"
                    {...itemProps}
                    ref={(r) => (items.current[itemIndex++] = r)}
                  >
                    Vimeo
                  </SplitText>
                </Link>
              </li> */}
            </ul>
          </div>

          <div className="footer-inner__right">
            <BoxedLogo />
            <BorderedIcon
              offset={-0.25}
              href="mailto:cu@nine.nl"
              text="Contact us"
              dontTriggerPageTransition
            />
          </div>
        </FooterInner>
      </Wrapper>
      <SectionTitle />

      <FooterBottom>
        <p>Nine Creative Agency - {year}</p>
        <div className="footer-bottom__right">
          <Link
            href="/files/algemene-voorwaarden.pdf"
            alt="Algemene voorwaarden"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SplitText tag="p" animateOnScroll>
              Algemene voorwaarden
            </SplitText>
          </Link>
          <Link
            href="/files/privacy-beleid.pdf"
            alt="Privacyverklaring"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SplitText tag="p" animateOnScroll>
              Privacy
            </SplitText>
          </Link>
        </div>
      </FooterBottom>
    </footer>
  );
}

const Wrapper = styled.div`
  ${util.inner}

  position: relative;

  .icon-container {
    position: absolute;
    top: 75%;
    transform: translateY(-50%);
    /* right: ${misc.pagePadding()}; */

    ${mediaMobile(`
      position: relative;
      padding-left: ${misc.pagePadding()};
      right: 0;
      top: 0;
      margin-top: 150rem;
      
    `)}
  }
`;

const FooterInner = styled.div`
  .footer-inner__left {
    display: flex;
    gap: 150rem;

    max-width: 70%;
  }

  .footer-inner__right {
    /* width: 100%; */
    width: 600rem;
    max-width: 20%;

    display: flex;
    flex-direction: column;
    gap: 100rem;
  }

  display: flex;
  justify-content: space-between;

  ul {
    li {
      margin-bottom: 20rem;

      p {
        ${({ theme: { locale } }) => setTypography("smallParagraph", locale)};
      }
    }

    li:has(a) p {
      position: relative;
      cursor: pointer;
      ${util.iconUnderlineHover("0.4s")}
      &:hover {
        ${util.iconUnderlineHoverTransition}
      }
    }
  }

  ${mediaMobile(`
    flex-flow: column wrap;
    gap: 30rem;

    .footer-inner__left {
        max-width: 100%;
        gap: 0rem;
        flex-wrap: wrap;
      }

      .footer-inner__right {
        max-width: 100%;

        // align-items: flex-end;
      }

    ul {
      flex: 50%;
      margin-bottom: 50rem;
    }

    .footer-inner {
      display: flex;
      
      

      
    }
  `)}
`;

const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;

  padding: 70rem ${misc.pagePadding()};

  .footer-bottom__right {
    display: flex;
    gap: 50rem;
    p {
      ${({ theme: { locale } }) => setTypography("smallParagraph", locale)};
    }
  }
  li p {
    cursor: pointer;
    position: relative;

    ${util.iconUnderlineHover("0.4s")}
    &:hover {
      ${util.iconUnderlineHoverTransition}
    }
  }

  ${mediaMobile(`
    p {
      font-size: 30rem;
    }
  `)}
`;
